import { colornames } from "color-name-list";

// Convert hex string (e.g., "#f2cd99") to [R, G, B]
export function hexToRgb(hex) {
  hex = hex.replace(/^#/, "");
  const bigint = parseInt(hex, 16);
  return [(bigint >> 16) & 255, (bigint >> 8) & 255, bigint & 255];
}

// Convert [R, G, B] to hex string (e.g., "#f2cd99")
export function rgbToHex(rgb) {
  return (
    "#" +
    rgb
      .map((num) => {
        const hex = num.toString(16);
        return hex.length === 1 ? "0" + hex : hex;
      })
      .join("")
  );
}

// RGB Euclidean distance
export function colorDistance(rgb1, rgb2) {
  const [dr, dg, db] = [
    rgb1[0] - rgb2[0],
    rgb1[1] - rgb2[1],
    rgb1[2] - rgb2[2],
  ];
  return Math.sqrt(dr * dr + dg * dg + db * db);
}

// Nearest color name for a hex
export function getNearestColorName(hex) {
  const targetRgb = hexToRgb(hex);
  let bestMatch = "";
  let minDistance = Infinity;

  for (const color of colornames) {
    const candidateRgb = hexToRgb(color.hex);
    const distance = colorDistance(targetRgb, candidateRgb);
    if (distance < minDistance) {
      minDistance = distance;
      bestMatch = color.name;
    }
  }
  return bestMatch;
}

// Convert hex to {r, g, b} float (0–1 range)
export function hexToFloatRGB(hex) {
  const r = parseInt(hex.slice(1, 3), 16) / 255;
  const g = parseInt(hex.slice(3, 5), 16) / 255;
  const b = parseInt(hex.slice(5, 7), 16) / 255;
  return { r, g, b };
}
